import { apiClient } from '@/shared/api/apiClient.ts';
import { handleRequest } from '@/shared/api/apiWrapper.ts';
import type {
  CommissionDepositOperationParams,
  CreateDepositOperationParams,
  DepositCreateOperationType,
  WithdrawType,
} from '@/shared/types';
import { objectToQueryParamsStr } from '@/shared/utils';

export const createWithdrawOperation = async <
  TResponse,
  TData extends Pick<
    CreateDepositOperationParams,
    'accountNumber' | 'amount' | 'currencyCode'
  > = CreateDepositOperationParams,
>(
  operationType: WithdrawType,
  data: TData
): Promise<TResponse> => {
  const response = await apiClient.post<TResponse>(
    `/operations/${operationType}/withdraw`,
    data
  );
  return response.data;
};

export const getWithdrawCommission = async <
  TResponse,
  TParams extends Record<string, string | number> &
    object = CommissionDepositOperationParams,
>(
  type: DepositCreateOperationType,
  params: TParams
): Promise<TResponse> => {
  const request = () => {
    const queryParams = objectToQueryParamsStr(params);

    return apiClient.get(
      `/operations/${type}/withdraw/commission?${queryParams}`
    );
  };

  const response = await handleRequest(request);

  return response.data;
};
